import React from 'react';
const IconMiscSteps = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M2 4V8H22V4H2ZM22 20H2V16H22V20ZM6 17H4V19H6V17ZM4 7H6V5H4V7ZM2 14H22V10H2V14ZM6 11H4V13H6V11Z" fill="#666666"/>
</svg>
);
};
export default IconMiscSteps;